
import { UserModule } from '~/store/modules/user';
import { Component, Vue, Prop } from 'vue-property-decorator';
import NetatmoIcon from '~/components/NetatmoIcon.vue';
import { HomeData } from '~/interfaces/home.interface';

@Component({
    components: {
        NetatmoIcon,
    },
})
export default class RemoveUserButton extends Vue {
    @Prop() home!: HomeData;
    @Prop() userMail!: string;
    @Prop() userId!: string;

    isDialogOpen = false;

    async removeUserFromHome() {
        UserModule.removeUserFromHome({ homeId: this.home.id, userId: this.userId });
        this.isDialogOpen = false;
    }
}
